<template>
    <div id="page-news-details">
      <news-form
          v-model="model"
          ref="form"
          :loading="loading"
          card-title="Create News"
      />
  
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-start">
            <vs-button
              @click="$router.push({ name: 'content-management.news.list' })"
              class="mr-4 my-4"
            >
              Cancel
            </vs-button>
            <vs-button
                v-if="componentAccess.canPublish.access && model"
                class="mr-4 my-4"
                color="light"
                @click="openEnableAlert(model)"
            >
              {{ model.IsEnabled ? "Deactivate" : "Activate" }}
            </vs-button>
          </div>
        </div>
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button
              :disabled="loading"
              @click="update"
              class="my-4"
              color="light"
            >
              Save
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import NewsForm from "@/views/pages/content-management/news/Form";
  import NotificationMixin from "@/components/mixins/NotificationMixin";
  import ViewModelMixin from "@/components/mixins/ViewModelMixin";
  import SaveModelMixin from '@/components/mixins/SaveModelMixin';
  import EnablePublishMixin from '@/components/mixins/EnablePublishMixin';
  import CanAccessMixin from '@/components/mixins/CanAccessMixin';
  
  export default {
    name: "NewsEdit",
    components: {
      NewsForm
    },
    mixins: [ViewModelMixin, NotificationMixin, SaveModelMixin, EnablePublishMixin, CanAccessMixin],
    data() {
      return {
        model: {},
        loading: false,
        modelEntity: this.$api.contentManagementNews,
        componentAccess: {
          canPublish: {
            route: 'content-management.news.publish',
            access: false,
          },
        },
      };
    },
    methods: {
    async fetch(id) {
      if (!this.modelEntity || !id) {
        return;
      }

      try {
        this.loading = true;
        await this.$store.dispatch('updateIsLoading', true);
        const {
          data
        } = await this.modelEntity.get(id);
        
        this.model = {
          ...data.data,
          applications: {},
        };
         
        if (data.data.applications) {
          data.data.applications.forEach((app) => {
            this.model.applications[`application_${app.Application_FK}`] = true;
          });
        }

        await this.$store.dispatch('updateIsDeleted', this.model.IsDeleted || false);
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false;
        await this.$store.dispatch('updateIsLoading', false);
        if (!this.model.id) {
          this.not_found = true
        }
      }
    },
      getParams() {
        const params = {
          ...this.model
        }
  
        const references = [
          'SalesCountryType_FK',
        ]
        
        const dates = [
          'NewsValidFrom',
          'NewsValidTo',
        ]

        references.forEach((ref) => params[ref] = this.getReferenceId(ref))
        this.setDates(dates, params);

        if (params.companies && params.companies.length) {
          const multiReferences = [
            {
              array: 'companies',
              key: 'Company_FK'
            },
          ];

          this.setMultiReferences(multiReferences, params);
        }
  
        return params;
      },
      getReferenceId(fieldName) {
        if (!this.model[fieldName]) {
          return null;
        }
  
        return this.model[fieldName].id || null;
      },
      async update() {
        if (!this.$refs.form.validate()) {
          this.notifyError('Not all required fields have been provided');
          return false;
        }
  
        // this.loading = true;
        const params = this.getParams();

        if (!params.IsNewsForAll
          && (!params.applications || !Object.keys(params.applications).length)
        ) {
          this.notifyError('Please select at least one Application');
          return false;
        }
  
        console.log(params);
        //  return;
        try {
          const {data} = await this.$api.contentManagementNews.update(this.id, params);
          this.notifySuccess('News created');
          this.$router.back();
        } catch (e) {
          this.notifyError('News failed to be created');
          console.error(e)
        } finally {
        }
      }
    },
  };
  </script>
  
  <style scoped>
  
  </style>
  